import { runInAction, makeObservable, observable, action } from "mobx";
import { getGeneralItems } from "../services/getLearningItemService";
import LoadingStatus from "../constants/loadingStatus";

class GeneralItemStore {
  data = [];
  loadingStatus = LoadingStatus.notStart;

  constructor() {
    makeObservable(this, {
      data: observable,
      loadingStatus: observable,
      load: action
    });
  }

  load = async (tag, keyword = "") => {
    try {
      this.loadingStatus = LoadingStatus.notStart;
      const rlt = await getGeneralItems(tag, keyword);
      runInAction(() => {
        this.data = rlt.data;
        this.loadingStatus = LoadingStatus.loaded;
      });
    } catch {
      this.loadingStatus = LoadingStatus.error;
      console.log("Error loading learn content");
    }
  };
}

const store = new GeneralItemStore();
export default store;
export { GeneralItemStore };
